import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://axfkablwysnukojhymip.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF4ZmthYmx3eXNudWtvamh5bWlwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU3OTA1ODIsImV4cCI6MjA3MTM2NjU4Mn0.N1qu_Ke9I_HHq9UbCjGA_Ws9IQ_GbiMbbIbTeG3-EBo';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);